import { clamp, isNil, round } from 'lodash';
import rewardTypes from '@enums/reward-types';
import requirementTypes from '@enums/requirement-types';
import { getTierPrimaryReward, getTierRequirementAmount } from './mechanic-reader';

const toPercent = value =>
    isNil(value) || Number.isNaN(value) ? null : clamp(round(value), 0, 100);

const fromPrices = ({ regularPrice, promoPrice }) =>
    isNil(regularPrice) || regularPrice <= 0 || isNil(promoPrice)
        ? null
        : (1 - promoPrice / regularPrice) * 100;

// Rewards that carry their own percentage; everything else is derived from prices.
const rules = {
    [rewardTypes.savePercent]: ({ reward }) => reward.amount,
    [rewardTypes.getNFree]: ({ reward, offerMechanic, tierIndex }) => {
        const buy = getTierRequirementAmount(offerMechanic, tierIndex, requirementTypes.buyNumber);
        const free = reward.amount;
        return buy && free ? (free / (buy + free)) * 100 : null;
    },
};

/**
 * Discount % shown on a price tag for one tier. Returns null when it cannot be worked out.
 */
export function getTierDiscountPercent({ offerMechanic, tierIndex, regularPrice, promoPrice }) {
    const reward = getTierPrimaryReward(offerMechanic, tierIndex);
    const rule = reward && !isNil(reward.amount) ? rules[reward.type] : null;
    const value = rule
        ? rule({ reward, offerMechanic, tierIndex })
        : fromPrices({ regularPrice, promoPrice });
    return toPercent(value);
}

export default { getTierDiscountPercent };
